import { render, staticRenderFns } from "./SalMonth.vue?vue&type=template&id=9479f3f0&scoped=true&"
import script from "./SalMonth.vue?vue&type=script&lang=js&"
export * from "./SalMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9479f3f0",
  null
  
)

export default component.exports